import React, { useEffect, useState } from 'react';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { format } from 'date-fns';
import { dateIndo, getStatusRewards } from '../../utilities/helper';
import ModalAbsentDetail from '../../components/Absents/modalDetailAbsent';
import ModalAbsentCreate from '../../components/Absents/modalCreateAbsent';
import ModalFilterAbsent from '../../components/Absents/modalFilterAbsent';
import ExportToExcel from '../../components/Exports/ExportToExcel';

const Absents = () => {
    const [datas, setDatas] = useState([])
    const [data, setData] = useState([])
    const [showModalDetail, setShowModalDetail] = useState(false)
    const [showModalCreate, setShowModalCreate] = useState(false)
    const [showModalFilter, setShowModalFilter] = useState(false)
    const [fetchMore, setFetchMore] = useState(true)
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    const [division, setDivision] = useState("")
    const [divisionSlug, setDivisionSlug] = useState("")
	const fileName = "Report_Absents_" + format(new Date(), "yyyy-MM-dd_HH:mm:ss");

    useEffect(() => {
        setFetchMore(false)
        
        // eslint-disable-next-line
    }, [fetchMore])

    const columns = [
        { 
            field: 'start_date', 
            headerName: 'Tanggal Absent',
            width: 250, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {dateIndo(params.row.start_date)} - {dateIndo(params.row.end_date)}
                    </div>
                )
            } 
        },
        { 
            field: 'Absence_Requester.fullname', 
            headerName: 'Pegawai',
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.Absence_Requester.nip} - {params.row.Absence_Requester.fullname} 
                    </div>
                )
            } 
        },
        { 
            field: 'Absence_Requester.Biodata.Echelon.title', 
            headerName: 'Eselon',
            width: 100, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.Absence_Requester.Biodata.Echelon.title}
                    </div>
                )
            } 
        },
        { 
            field: 'Absence_Requester.Biodata.Office.name', 
            headerName: 'Divisi',
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.Absence_Requester.Biodata.Office.name}
                    </div>
                )
            } 
        },
        { 
            field: 'type', 
            headerName: 'Absen',
            width: 150, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp uppercase'>
                        {params.row.type}
                    </div>
                )
            } 
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        <span className={`px-2 py-1 ${getStatusRewards(params.row.status)} rounded-full text-white uppercase`}>{params.row.status}</span>
                    </div>
                )
            } 
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className='w-full flex flex-row items-center gap-3'>
                        <VisibilityIcon fontSize='medium' className="text-slate-400 hover:text-slate-500 cursor-pointer" onClick={() => handleDetail(params.row)}/>
                    </div>
                )
            }
        },
    ]

    const handleDetail = (tempData) => {
        setShowModalDetail(true)
        setData(tempData)
    }

    const reportDatas = datas.map(item => (
		{ 
			"Mulai Tanggal": dateIndo(item.start_date), 
			"Sampai Tanggal": dateIndo(item.end_date), 
			"Nama Lengkap": item.Absence_Requester.fullname, 
			"NIP": item.Absence_Requester.nip, 
			"Divisi": item.Absence_Requester.Biodata.Office.name,
			"Note": item.note, 
			"Tipe": item.type, 
            "Photo": item.photo ? `https://binar.hadiahkugratis.com/api-BinarHC/images/${item.photo}` : "",
			"Status": item.status,
            "Admin": item.Absence_Approver?.fullname
		}
	));

    return (
        <>
            {showModalFilter && 
                <ModalFilterAbsent setShowModalFilter={setShowModalFilter} setDatas={setDatas} setFetchMore={setFetchMore} setStartTime={setStartTime} setEndTime={setEndTime} setDivision={setDivision} setDivisionSlug={setDivisionSlug} />
            }
            {showModalDetail &&
                <ModalAbsentDetail setShowModalDetail={setShowModalDetail} data={data} setDatas={setDatas} startTime={startTime} endTime={endTime} divisionSlug={divisionSlug}/>
            }
            {showModalCreate &&
                <ModalAbsentCreate setShowModalCreate={setShowModalCreate}/>
            }

            <div className={`min-h-[calc(100vh-4rem)] flex flex-col ${showModalFilter && 'fixed min-w-[calc(100vw-16.666667%)]'}`}>
                {/* header  */}
                <div className="my-5 mb-5 mx-7 md:mx-5 flex flex-col md:flex-row justify-between items-start">
                    <div className=' flex flex-col'>
                        <h1 className='font-ssp font-bold text-2xl md:text-3xl'>Absents</h1>
                        {startTime 
                            ?
                                <span className='font-ssp font-normal text-sm md:text-xl'>{dateIndo(startTime)} - {dateIndo(endTime)}</span>
                            : ''
                        }

                        {division
                            ? <span className='font-ssp font-normal text-sm md:text-xl'>{division}</span> 
                            : <span className='font-ssp font-light text-sm md:text-base tracking-wide'>Lakukan filter tanggal dulu untuk menampilkan data</span>
                        }
                    </div>
                    <div className='flex flex-row flex-wrap gap-2'>
                        <div onClick={(e) => setShowModalFilter(true)} className="px-5 py-2.5 mr-3 mt-3 md:mt-1 bg-green-400 hover:bg-green-500 rounded-lg flex text-sm font-medium self-start md:self-end cursor-pointer">
                            <span className='text-sm text-white font-ssp'>Filter By Date</span>
                        </div>
                        <div onClick={(e) => setShowModalCreate(true)} className="px-5 py-2.5 mr-3 mt-3 md:mt-1 bg-blue-400 hover:bg-blue-500 rounded-lg flex text-sm font-medium self-start md:self-end cursor-pointer">
                            <span className='text-sm text-white font-ssp'>Add New</span>
                        </div>
                        {division
                            ?
                                <ExportToExcel reportDatas={reportDatas} fileName={fileName} />
                            : ""
                        }
                    </div>
                </div>
                {/* content  */}
                <div className="my-5 mb-5 mx-7 md:mx-5 flex">
                    <div className="p-2 w-full bg-white drop-shadow-lg rounded-md flex">
                        <DataGrid
                            autoHeight {...datas}
                            rows={datas}
                            columns={columns}
                            pageSize={10}
                            getRowId={(row) => row.id}
                            rowsPerPageOptions={[10]}
                            checkboxSelection
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar, }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Absents